import * as actionTypes from '../constants/actionTypes';

export default(state = {}, action) => {
    switch (action.type) {
        case actionTypes.CUSTOMER_LIST:
            return {
                ...state,
                list: action.payload
            };
        case actionTypes.CUSTOMER_GET:
            return {
                ...state,
                customer: action.payload
            };
        case actionTypes.CUSTOMER_CLEAR:
            return {
                ...state,
                customer: null
            };
        case actionTypes.CUSTOMER_GET_ADDITIONAL_DATA:
            return {
                ...state,
                additionalData: action.payload
            };
        default:
            return state;
    }
};